export default {
  "b2b.provozni-informace-detail.description-label.created": "Vytvořeno",
  "b2b.provozni-informace-detail.description-label.edited":
    "Poslední aktualizace",
  "b2b.provozni-informace-detail.header-action.edit": "EDITOVAT",
  "b2b.provozni-informace-detail.emptyMessage": "Provozní informace nenalezena"
};
